import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/base/SEOHead';

export default function ResourcesPage() {
  const resources = [
    {
      category: 'Business Planning',
      items: [
        { title: 'Business Plan Template', description: 'Comprehensive template for creating your business plan', icon: 'ri-file-text-line', link: '/resources/business-plan-template' },
        { title: 'Financial Projections Guide', description: 'Learn how to create accurate financial forecasts', icon: 'ri-line-chart-line', link: '/resources/financial-projections-guide' },
        { title: 'Market Research Tools', description: 'Resources for understanding your target market', icon: 'ri-search-line', link: '/resources/market-research-tools' },
      ],
    },
    {
      category: 'Legal & Compliance',
      items: [
        { title: 'Business Structure Guide', description: 'Choose the right legal structure for your business', icon: 'ri-building-line', link: '/resources/business-structure-guide' },
        { title: 'Permit & License Checklist', description: 'Complete list of required permits in El Paso', icon: 'ri-checkbox-line', link: '/resources/permit-license-checklist' },
        { title: 'Tax Registration Guide', description: 'Step-by-step tax registration process', icon: 'ri-file-list-3-line', link: '/resources/tax-registration-guide' },
      ],
    },
    {
      category: 'Funding Options',
      items: [
        { title: 'Small Business Loans', description: 'Local and federal loan programs available', icon: 'ri-bank-line', link: '/resources/small-business-loans' },
        { title: 'Grant Opportunities', description: 'Find grants for El Paso entrepreneurs', icon: 'ri-gift-line', link: '/resources/grant-opportunities' },
        { title: 'Investor Network', description: 'Connect with local investors and angel groups', icon: 'ri-team-line', link: '/resources/investor-network' },
      ],
    },
    {
      category: 'Marketing & Growth',
      items: [
        { title: 'Digital Marketing Guide', description: 'Build your online presence effectively', icon: 'ri-megaphone-line', link: '/resources/digital-marketing-guide' },
        { title: 'Branding Resources', description: 'Create a strong brand identity', icon: 'ri-palette-line', link: '/resources/branding-resources' },
        { title: 'Social Media Strategy', description: 'Leverage social platforms for growth', icon: 'ri-share-line', link: '/resources/social-media-strategy' },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Business Resources for El Paso Entrepreneurs - Templates, Tools & Guides"
        description="Access free business planning templates, financial tools, legal guides, funding resources, and marketing strategies for El Paso businesses. Comprehensive resources to help your Texas business succeed."
        canonical="/resources"
        keywords="El Paso business resources, business plan template, small business loans El Paso, Texas business grants, marketing resources, business funding Texas"
      />
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <header className="text-center mb-16">
            <h1 className="text-6xl font-bold text-gray-900 mb-6">Business Resources</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Access comprehensive tools, templates, and guides to help you start and grow your El Paso business successfully.
            </p>
          </header>

          <section className="space-y-16">
            {resources.map((section, index) => (
              <article key={index}>
                <h2 className="text-3xl font-bold text-gray-900 mb-8 pb-4 border-b-2 border-[#D2691E]">
                  {section.category}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {section.items.map((item, itemIndex) => (
                    <Link
                      key={itemIndex}
                      to={item.link || '#'}
                      className="bg-[#FAFAF8] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer block"
                    >
                      <div className="w-16 h-16 bg-[#D2691E] rounded-xl flex items-center justify-center mb-6">
                        <i className={`${item.icon} text-3xl text-white`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed mb-4">{item.description}</p>
                      <div className="text-[#D2691E] font-semibold text-sm hover:text-[#B8571A] transition-colors flex items-center space-x-2 whitespace-nowrap">
                        <span>Learn More</span>
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </Link>
                  ))}
                </div>
              </article>
            ))}
          </section>

          <aside className="mt-20 bg-[#1B3A3A] rounded-3xl p-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-4">Need Personalized Guidance?</h2>
            <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto">
              Connect with our team for customized support tailored to your specific business needs.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center space-x-3 bg-[#D2691E] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B8571A] transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              <span>Contact Us</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
}